export interface RunSettings {
  single_concurrency: boolean;
  node_parallelism: number;
}

export const MAX_NODE_PARALLELISM = 16;

export const DEFAULT_RUN_SETTINGS: RunSettings = {
  single_concurrency: false,
  node_parallelism: MAX_NODE_PARALLELISM,
};

export function countNonDefaultRunSettings(settings: RunSettings): number {
  return [
    settings.single_concurrency !== DEFAULT_RUN_SETTINGS.single_concurrency,
    settings.node_parallelism !== DEFAULT_RUN_SETTINGS.node_parallelism,
  ].filter(Boolean).length;
}

export function clampNodeParallelism(value: number): number {
  return Math.min(MAX_NODE_PARALLELISM, Math.max(1, Math.round(value)));
}

export function parseRunSettings(definition: {
  single_concurrency?: unknown;
  node_parallelism?: unknown;
}): RunSettings {
  const parallelism = definition.node_parallelism;
  return {
    single_concurrency: definition.single_concurrency === true,
    node_parallelism:
      typeof parallelism === "number" && Number.isFinite(parallelism)
        ? clampNodeParallelism(parallelism)
        : DEFAULT_RUN_SETTINGS.node_parallelism,
  };
}

export function serializeRunSettings(settings: RunSettings): {
  single_concurrency?: true;
  node_parallelism?: number;
} {
  return {
    ...(settings.single_concurrency ? { single_concurrency: true } : {}),
    ...(settings.node_parallelism !== DEFAULT_RUN_SETTINGS.node_parallelism
      ? { node_parallelism: settings.node_parallelism }
      : {}),
  };
}
